import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f76f478"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attachment-select-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-add" }, null, -1))
const _hoisted_3 = { class: "attachment-display-wrapper" }
const _hoisted_4 = { class: "attachment-list-wrapper" }
const _hoisted_5 = { class: "attachment-list-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileChooser = _resolveComponent("FileChooser")!
  const _component_BasicList = _resolveComponent("BasicList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FileChooser, {
      name: "attachment-file-selector",
      ref: "fileChooser",
      accept: _ctx.accept,
      showButton: false,
      buttonProps: _ctx.filePickerButtonProps,
      onChooseFiles: _ctx.addAttachment
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(this.$mhat("AttachmentSelector.AddAttachmentButtonText")), 1)
      ]),
      _: 1
    }, 8, ["accept", "buttonProps", "onChooseFiles"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BasicList, {
          list: _ctx.attachmentListLeft,
          "on-click": _ctx.removeAttachment,
          danger: "",
          "icon-class-right": "icon-cancel"
        }, null, 8, ["list", "on-click"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_BasicList, {
          list: _ctx.attachmentListRight,
          "on-click": _ctx.removeAttachment,
          danger: "",
          "icon-class-right": "icon-cancel"
        }, null, 8, ["list", "on-click"])
      ])
    ])
  ]))
}